import React from 'react';

function ClientCard({ data, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const renderField = (label, field, value) => (
    <div className="card-field">
      <div className="field-label">{label}</div>
      <input
        type="text"
        className="field-input"
        value={value || ''}
        onChange={(e) => handleChange(field, e.target.value)}
        placeholder="No disponible"
      />
    </div>
  );

  return (
    <div className="data-card">
      <div className="card-header">
        <h3>Cliente</h3>
      </div>
      <div className="card-body">
        {renderField('Nombre', 'nombre', data.nombre)}
        {renderField('NIF/CIF', 'nif', data.nif)}
        {renderField('Direccion', 'direccion', data.direccion)}
      </div>
    </div>
  );
}

export default ClientCard;
